const SESSION_KEY = "shuatibao_roadshow_session_id";

function randomId(): string {
  if (typeof crypto !== "undefined" && "randomUUID" in crypto) {
    return crypto.randomUUID();
  }
  return `${Date.now()}_${Math.random().toString(16).slice(2)}`;
}

export function getOrCreateSessionId(): string {
  const existing = localStorage.getItem(SESSION_KEY);
  if (existing) return existing;

  const next = `session_${randomId()}`;
  localStorage.setItem(SESSION_KEY, next);
  return next;
}
